import { render, staticRenderFns } from "./ClaimListV4.vue?vue&type=template&id=d147e802&scoped=true&"
import script from "./ClaimListV4.vue?vue&type=script&lang=js&"
export * from "./ClaimListV4.vue?vue&type=script&lang=js&"
import style0 from "./ClaimListV4.vue?vue&type=style&index=0&id=d147e802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d147e802",
  null
  
)

export default component.exports